namespace Shared.Dto

type MapSensorType =
    | Air
    | Soil
    | RainFall
    | LeafletMoisture
    | PH
    | WindAverage
    | WeatherStation
    | LiquidLevel
    | SolarRadiation
    | FourTimesSoil
    | Distance
    | Pressure
    | WaterQuality

[<RequireQualifiedAccess>]
module MapSensorType =
    let toString (mapSensorType: MapSensorType) =
        match mapSensorType with
        | MapSensorType.Air -> "Luft"
        | MapSensorType.Soil -> "Boden"
        | MapSensorType.RainFall -> "Regenmenge"
        | MapSensorType.LeafletMoisture -> "Blattnässe"
        | MapSensorType.PH -> "PH"
        | MapSensorType.WindAverage -> "Wind Durchschnitt"
        | MapSensorType.WeatherStation -> "Wetterstation"
        | MapSensorType.LiquidLevel -> "Wasserhöhe"
        | MapSensorType.SolarRadiation -> "Globalstrahlung"
        | MapSensorType.FourTimesSoil -> "4-fach Boden"
        | MapSensorType.Distance -> "Distanz"
        | MapSensorType.Pressure -> "Druck"
        | MapSensorType.WaterQuality -> "Wasserqualität"

    let fromString (mapSensorType: string) =
        match mapSensorType with
        | "Luft" -> Some MapSensorType.Air
        | "Boden" -> Some MapSensorType.Soil
        | "Regenmenge" -> Some MapSensorType.RainFall
        | "Blattnässe" -> Some MapSensorType.LeafletMoisture
        | "PH" -> Some MapSensorType.PH
        | "Wind Durchschnitt" -> Some MapSensorType.WindAverage
        | "Wetterstation" -> Some MapSensorType.WeatherStation
        | "Wasserhöhe" -> Some MapSensorType.LiquidLevel
        | "Globalstrahlung" -> Some MapSensorType.SolarRadiation
        | "4-fach Boden" -> Some MapSensorType.FourTimesSoil
        | "Distanz" -> Some MapSensorType.Distance
        | "Druck" -> Some MapSensorType.Pressure
        | "Wasserqualität" -> Some MapSensorType.WaterQuality
        | _ -> None